import { useMemo } from 'react';

export const useSearchQuery = () => useMemo(() => Object.fromEntries(new URLSearchParams(window.location.search).entries()), []);

export default useSearchQuery;
